import React from 'react';
import clsx from 'clsx';
import IconButton from './IconButton';

const CreateButton = ({
  className,
  disabled,
  entity,
  onClick,
  text,
}) => (
  <IconButton
    className={clsx('aridhia-create-button', className)}
    disabled={disabled}
    icon
    iconName="plus"
    iconOnly
    iconClassName="primary"
    messageId={`actions.create.${entity}.title`}
    onClick={onClick}
    text={text}
  />
);

export default CreateButton;
